<template>
    <div>
        <!-- <base-alert type="warning" dismissible v-if="showBaseAlert">
            <div>
                {{ baseAlertText }}
                </div>
            </base-alert>
            <button @click="showBaseAlert = !showBaseAlert">OK</button>-->

        <!-- <router-link to="/logmonitoring/monitoringForm"> -->
        <!-- <router-link to="/logmonitoring/addmonitoringForm">
            <base-button type="info" class="addIndicatorBtn"
                >Monitoring Form</base-button
            ></router-link
        >
        <router-link to="/logmonitoring/reports">
            <base-button type="info" class="addIndicatorBtn"
                >Reports</base-button
            ></router-link
        > -->
        <div class="addIndicatorWrapper">
            <base-button
                @click="openModal()"
                type="primary"
                class="addIndicatorBtn"
                ><i class="el-icon-plus"></i>Add Indicator</base-button
            >
        </div>
        <modal
            class="modal alert"
            v-if="showAlert"
            :show.sync="showAlert"
            headerClasses="justify-content-center"
            >Are you sure to delete this indicator?
            <br />
            <base-button
                @click="deleteIndicator()"
                class="alert__button"
                type="info"
                >Yes</base-button
            >&nbsp;
            <base-button
                @click="showAlert = false"
                type="warning"
                class="alert__button"
                >No</base-button
            >
            <div class="errorAlert">
                {{ deleteAlertText }}
            </div>
        </modal>
        <modal
            class="modal"
            v-if="showForm"
            :show.sync="showForm"
            headerClasses="justify-content-center"
        >
            <h3 v-if="!isUpdate">Add Indicator</h3>
            <h3 v-if="isUpdate">Update Indicator</h3>

            <el-form
                ref="form"
                :model="form"
                label-width="120px"
                v-if="showForm"
                class="form"
                style="
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                    padding: 0px;
                "
            >
                <!-- <div class="select input">
                    Indicator Type :
                    <el-select
                        v-model="form.indicator_type"
                        placeholder="Select Indicator Type"
                        class="select__field"
                    >
                        <el-option
                            v-for="item in indicatorTypes"
                            :key="item.id"
                            :label="item.type"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </div> -->
                <div
                    style="
                        display: flex;
                        flex-wrap: nowrap;
                        flex-direction: row;
                    "
                >
                    <div class="input">
                        Type :
                        <el-select
                            v-model="form.resultChainType"
                            placeholder="Type"
                            class="select__field field input__field"
                            :disabled="resultChainDisabled"
                            style="width: 208px"
                        >
                            <!-- .el-input.el-input--suffix {
    width: 208px;
} -->
                            <el-option
                                v-for="item in resultChainTypes"
                                :key="item.id"
                                :label="item.type"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="input">
                        Result Chain :
                        <el-select
                            v-model="form.resultChain"
                            placeholder="Result Chain"
                            class="select__field field input__field"
                            :disabled="resultChainDisabled"
                        >
                            <el-option
                                v-for="item in resultChainList"
                                :key="item.id"
                                :label="item.resultChain"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div
                    style="
                        display: flex;
                        flex-wrap: nowrap;
                        flex-direction: row;
                    "
                >
                    <div class="input">
                        Indicator ID :
                        <el-input
                            v-model="form.indicator_code"
                            placeholder="Indicator ID"
                            class="input__field"
                        ></el-input>
                    </div>
                    <div class="input">
                        Indicator Name :
                        <el-input
                            v-model="form.indicator_name"
                            placeholder="Indicator Name"
                            class="input__field"
                        ></el-input>
                    </div>
                </div>
                <div
                    style="
                        display: flex;
                        flex-wrap: nowrap;
                        flex-direction: row;
                    "
                >
                    <div class="input" style="width: 434px">
                        Metric :
                        <el-input
                            v-model="form.metric"
                            placeholder="Metric"
                            class="input__field"
                            style="width: 434px"
                        >
                        </el-input>
                        <div
                            style="
                                color: lightslategray;
                                margin-left: 10px;
                                max-width: 500px;
                            "
                        >
                            If several metrics are to be entered, please use a
                            comma to separate them.
                        </div>
                    </div>
                    <!-- <div class="input">
                    Description :
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 5 }"
                        placeholder="Description"
                        v-model="form.description"
                    >
                    </el-input>
                </div> -->
                </div>
            </el-form>
            <div class="errorAlert">{{ baseAlertText }}</div>
            <base-button @click="addIndicator()" v-if="!isUpdate" type="info"
                >Submit</base-button
            >
            <base-button @click="updateIndicator()" v-if="isUpdate" type="info"
                >Update</base-button
            >
        </modal>
        <el-table :data="tableData" style="width: 100%" class="table">
            <el-table-column
                prop="resultChainType"
                label="Result Chain Type"
                class="table__column"
                sortable
            >
            </el-table-column>
            <el-table-column
                prop="resultChain"
                label="Result Chain"
                class="table__column"
                sortable
            >
            </el-table-column>
            <el-table-column
                prop="indicatorCode"
                label="Indicator ID"
                class="table__column"
                sortable
            >
            </el-table-column>
            <el-table-column
                prop="indicator"
                label="Indicator Name"
                class="table__column"
                sortable
            >
            </el-table-column>
            <!-- <el-table-column
                prop="type"
                label="Indicator Type"
                class="table__column"
                sortable
            >
            </el-table-column> -->
            <el-table-column
                prop="metric"
                label="Indicator Metric"
                class="table__column"
                sortable
            >
            </el-table-column>
            
            <!-- <el-table-column
                prop="description"
                label="Description"
                class="table__column"
                sortable
            >
            </el-table-column> -->
            <el-table-column
                prop="custom"
                label="Custom"
                class="table__column"
                sortable
            >
            </el-table-column>
            <el-table-column label="" class="table__column">
                <template slot-scope="scope">
                    <!-- <i
                    class="el-icon-edit"
                        @click="handleEdit(scope.$index, scope.row)"
                        style="color:blue;font-size:larger;"
                        ></i> -->
                    <base-button
                        size="sm"
                        type="info"
                        @click="handleEdit(scope.$index, scope.row)"
                        class="table__button"
                        >Edit<i class="el-icon-edit"></i
                    ></base-button>
                    <base-button
                        size="sm"
                        type="warning"
                        @click="handleDelete(scope.$index, scope.row)"
                        class="table__button"
                        >Delete<i class="el-icon-delete"></i
                    ></base-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- {{this.tableData.length}} -->
        <div class="pagination-border">
            <base-pagination
                @input="getIndicators"
                class="pagination-no-border"
                v-model="pagination.current_page"
                :per-page="pagination.per_page"
                :total="pagination.total"
            >
            </base-pagination>
        </div>
    </div>
</template>
<style lang="scss">
.el-select-dropdown__wrap.el-scrollbar__wrap {
    width: 431px;
}
</style>
<style scoped lang="scss">
.pagination-border {
    background-color: #0000003d;
    padding: 10px;
}
.errorAlert {
    color: red;
}
.table {
    margin-top: 10px;
    &__button {
        margin: 20px !important;
    }
    &__column {
        text-align: center !important;
    }
}
.addIndicatorWrapper {
    padding: 20px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    .addIndicatorBtn {
        transform: translateY(-3px);
        color: #90c14f;
        background: #f5f6fa !important;
    }
}

.alert {
    min-height: 25vh;
    color: rgba(34, 42, 66, 0.7);
    padding: 30px;
    &__button {
        margin: 10px;
        margin-left: auto;
    }
}

.form {
    //     display: grid;
    // grid-template-columns: repeat(3, 1fr);
    // grid-template-rows: repeat(3, 1fr);
    // grid-column-gap: 0px;
    // grid-row-gap: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    // gap:5;
    .input {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;

        &__field {
            // max-width: 30vw;
        }
    }
    .select {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;
        &__field {
            max-width: 30vw;
            border-color: 1px solid;
        }
    }
}
// .btn:not(:disabled):not(.disabled) {
//     margin: 10px;
// }
</style>
<script>
import { LogMonitoringService } from "@/services";
import { Table, TableColumn, Select, Option, Pagination } from "element-ui";
import { Modal, BaseAlert, BasePagination } from "src/components";
export default {
    name: "indicator-form",
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Modal,
        BaseAlert,
        BasePagination,
        [Select.name]: Select,
        [Option.name]: Option,
        Pagination,
    },
    data() {
        return {
            showForm: false,
            showAlert: false,
            showBaseAlert: false,
            baseAlertText: "",
            deleteAlertText: "",
            deleteID: "",
            isUpdate: false,
            tableData: [],
            page: 1,
            indicatorTypes: [],
            pagination: {
                current_page: 1,
                per_page: 5,
                total: 10,
            },
            resultChainTypes: [],
            resultChainList: [],
            resultChainDisabled: false,
            resultChain_forEdit: "",
            isCurrentlyEditing: false,
            isCustom: false,

            form: {
                id: "",
                indicator_code: "",
                indicator_name: "",
                application_id: "",
                indicator_type: "",
                metric: "",
                result: "",
                baseline: "",
                target: "",
                baseline_comment: "",
                target_comment: "",
                means_of_verification: "",
                indicator_reference: "",
                created_at: "",
                updated_at: "",
                deleted_at: "",
                description: "",
                resultChainType: "",
                resultChain: "",
                custom: "",
            },

            form2: {
                Grant_ID: "",
                // ISO3(or country long name):"",
                ISO3: "",
                Region: "",
                Indicator_ID: "",
                Indicator_name: "",
                Baseline_value: "",
                Baseline_metric: "",
                Final_value: "",
                Final_metric: "",
            },
        };
    },
    methods: {
        setPage(val) {
            this.page = val;
        },
        onSubmit() {
            console.log("submit!");
        },
        openModal() {
            this.form.indicator_code = "";
            this.form.indicator_name = "";
            this.form.metric = "";
            this.form.indicator_type = "";
            this.form.description = "";
            this.form.resultChainType = "";
            this.form.resultChain = "";
            this.showForm = !this.showForm;
            this.isUpdate = false;
            this.baseAlertText = "";
            this.resultChainList = [];
        },
        async getIndicators(page) {
            let page_to_get = page || this.pagination.current_page;
            await LogMonitoringService.getIndicators({
                page: page_to_get,
                per_page: this.pagination.per_page,
            }).then((response) => {
                this.tableData = response.data.data.data;
                this.pagination.total = response.data.data.total;
                // console.log("Tabledata : ", response);
            });
        },
        async getIndicatorTypes() {
            await LogMonitoringService.getIndicatortypes().then((response) => {
                this.indicatorTypes = response.data.data;
                console.log(this.indicatorTypes);
            });
        },
        async addIndicator() {
            // if (
            //     this.form.indicator_code == "" ||
            //     this.form.metric == "" ||
            //     this.form.indicator_type == "" ||
            //     this.form.indicator_name == ""
            // )
            if (
                this.form.indicator_code == "" ||
                this.form.metric == "" ||
                this.form.indicator_name == "" ||
                this.form.resultChainType == "" ||
                this.form.resultChain == ""
            ) {
                this.baseAlertText =
                    "Please input all fields before submission";
                console.log("No data");
                return;
            }
            const data = {
                indicator_code: this.form.indicator_code,
                indicator: this.form.indicator_name,
                indicator_type_id: this.form.indicator_type,
                metric: this.form.metric,
                description: this.form.description,
                result_chain: this.form.resultChain,
                result_chain_type: this.form.resultChainType,
            };
            await LogMonitoringService.addIndicator(data)
                .catch((response) => {
                    this.baseAlertText =
                        "The indicator ID has already been taken.";
                    // this.showBaseAlert = true;
                    // alert(this.baseAlertText);
                })
                .then((response) => {
                    console.log(response);
                    if (response.error) {
                        this.baseAlertText = response.error;
                        this.showBaseAlert = true;
                    }
                    this.form.indicator_code = "";
                    this.form.indicator_name = "";
                    this.form.description = "";
                    this.form.metric = "";
                    this.form.indicator_type = "";
                    this.form.resultChainType = "";
                    this.form.resultChain = "";
                    this.showForm = false;
                    this.getIndicators();
                    console.log("Added indicator");
                });
        },
        async updateIndicator() {
            // if (
            //     this.form.indicator_code == "" ||
            //     this.form.indicator_name == ""
            // ) {
            //     console.log("No data");
            //     return;
            // }
            // if (
            //     this.form.indicator_code == "" ||
            //     this.form.metric == "" ||
            //     this.form.indicator_type == "" ||
            //     this.form.indicator_name == ""
            // )
            if (
                this.form.indicator_code == "" ||
                this.form.metric == "" ||
                this.form.indicator_name == "" ||
                this.form.resultChainType == "" ||
                this.form.resultChain == ""
            ) {
                this.baseAlertText =
                    "Please input all fields before submission";
                console.log("No data");
                return;
            }
            const data = {
                id: this.form.id,
                indicator_code: this.form.indicator_code,
                indicator: this.form.indicator_name,
                indicator_type_id: this.form.indicator_type,
                metric: this.form.metric,
                description: this.form.description,
                result_chain: this.form.resultChain,
                result_chain_type: this.form.resultChainType,
                custom: this.form.custom,
            };
            await LogMonitoringService.updateIndicator(data)
                .catch((response) => {
                    this.baseAlertText =
                        "The indicator ID has already been taken.";
                    // this.showBaseAlert = true;
                    // alert(this.baseAlertText);
                    return;
                })
                .then((response) => {
                    console.log(response);
                    if (response.error) {
                        this.baseAlertText = response.error;
                        this.showBaseAlert = true;
                    }
                    this.form.indicator_code = "";
                    this.form.indicator_name = "";
                    this.form.description = "";
                    this.form.indicator_type = "";
                    this.form.metric = "";
                    this.form.resultChainType = "";
                    this.form.resultChain = "";
                    this.showForm = false;
                    this.isUpdate = false;
                    this.getIndicators();
                    console.log("Updated indicator");
                });
            this.isCustom = false;
        },
        async handleEdit(index, row) {
            console.log("Index : ", index);
            console.log("Row : ", row);
            if (row.custom == "Custom") {
                this.resultChainDisabled = true;
            } else {
                this.resultChainDisabled = false;
            }
            this.baseAlertText = "";
            if (row.custom == "Custom") {
                this.isCustom = true;
            } else {
                this.isCustom = false;
            }
            await LogMonitoringService.getIndicator(row.id).then((response) => {
                this.getIndicators();
                console.log(response);
                this.form.id = response.data.data.id;
                this.form.indicator_code = response.data.data.indicatorCode;
                this.form.indicator_name = response.data.data.indicator;
                // this.form.indicator_type = response.data.data.indicatorTypeId;
                this.form.metric = response.data.data.metric;
                this.form.description = response.data.data.description;
                // this.form.resultChain = response.data.data.resultChainId;
                this.form.resultChainType =
                    response.data.data.resultChainTypeId;
                this.form.custom = row.custom != null ? 1 : 0;
                this.resultChain_forEdit = response.data.data.resultChainId;
                this.isUpdate = true;
                this.showForm = true;
                this.isCurrentlyEditing = true;
            });
        },
        async handleDelete(index, row) {
            this.deleteID = row.id;
            this.showAlert = true;
            this.deleteAlertText = "";
        },
        async deleteIndicator() {
            await LogMonitoringService.deleteIndicator({
                id: this.deleteID,
            }).then((response) => {
                console.log(response);
                if (
                    response.data.warning ===
                    "This indicator used in an application cannot be deleted."
                ) {
                    this.deleteAlertText =
                        "This indicator is used in an application and cannot be deleted.";
                } else {
                    console.log(response);
                    this.showAlert = false;
                    this.getIndicators();
                }
            });
        },
        async getResultChainTypes() {
            await LogMonitoringService.getResultChainTypes().then(
                (response) => {
                    this.resultChainTypes = response.data.data;
                }
            );
        },
    },
    mounted() {
        this.getIndicators();
        this.getIndicatorTypes();
        this.getResultChainTypes();
    },
    watch: {
        "form.resultChainType": async function (val) {
            // if (!this.isUpdate) {
            this.form.resultChain = "";
            // }
            await LogMonitoringService.getResultChain({
                type_id: this.form.resultChainType,
            }).then((response) => {
                this.resultChainList = response.data.data;
                console.log("Response of Result Chain", this.resultChainList);
                if (this.isUpdate && this.isCurrentlyEditing) {
                    this.form.resultChain = this.resultChain_forEdit;
                    this.isCurrentlyEditing = false;
                }
            });
        },
    },
};
</script>
